module.exports = __webpack_public_path__ + "static/media/verified.d4b3e367.png";